import React from "react";
import { Link } from "react-router-dom";

function Footer() {
	return (
		<footer className="mt-14">
			<div className="bg-gradient-to-r from-teal-50 via-slate-100 to-orange-50 py-8">
				<div className="gandal-container text-black">
					<h1 className="text-center font-semibold text-lg">
						<a href="/" translate="no">
							Gandal
						</a>
					</h1>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipisicing elit.
						Adipisci odit libero sed unde dicta! Iusto quisquam ipsa
						tempora, maxime sunt, explicabo consectetur esse facere nam
						voluptate ipsam nihil pariatur. Excepturi. Lorem ipsum dolor sit
						amet, consectetur adipisicing elit. Adipisci odit libero sed
						unde dicta! Iusto quisquam ipsa tempora, maxime sunt, explicabo
						consectetur esse facere nam voluptate ipsam nihil pariatur.
						Excepturi. Lorem ipsum dolor sit amet, consectetur adipisicing
						elit. Adipisci odit libero sed unde dicta! Iusto quisquam ipsa
						tempora, maxime sunt, explicabo consectetur esse facere nam
						voluptate ipsam nihil pariatur. Excepturi.
					</p>
					<div className="flex justify-center mt-4">
						<ul className="flex items-center  gap-5">
							<li>
								<Link
									to="/"
									className="underline hover:font-medium"
								>
									BAC
								</Link>
							</li>
							<li>
								<Link
									to="/"
									className="underline hover:font-medium"
								>
									BEPC
								</Link>
							</li>
							<li>
								<Link
									to="/"
									className="underline hover:font-medium"
								>
									CEP
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="bg-black py-2 text-white">
				<div className="gandal-container flex justify-between flex-col items-center md:flex-row">
					<div className="flex gap-2">
						© 2022
						<Link to="/" className="underline text-white" translate="no">
							gandal.com
						</Link>
						Tous Droits Réservés.
					</div>
					<div className="flex gap-1">
						Développé et mise en ligne par
						<a
							href="/"
							className="underline text-white"
							translate="no"
							target="_blank"
						>
							alphakahere
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
